import SkapaToggle, { type ToggleProps } from "@ingka/toggle";

export const Toggle = (props: ToggleProps) => {
  return <SkapaToggle prefix="saleslead__" {...props} />;
};
